import React from 'react';
import UserGroupCardItem from './UserGroupCardItem';

const UserGroupCardItems = ({ items, onCheckBoxClick, single }) => (
  items.map((item, index) => (
    <UserGroupCardItem
      key={`usergroup_card_item_${item.id}`}
      onCheckBoxClick={onCheckBoxClick}
      single={single}
      upward={index > 4}
      userGroup={item}
    />
  ))
);

export default UserGroupCardItems;
